query ListMyShopifyShops {
  shops: StreamToolsListMyShopifyShops {
    shop
    appKey
    registeredAt
    lastWebhookAt
    connectionStatus
  }
}
